export default "__VITE_PUBLIC_ASSET__ecd3bc38__"